var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.selectedComponentComputed,{tag:"component",attrs:{"value":_vm.valueComputed}})
}
var staticRenderFns = []

export { render, staticRenderFns }